<template>
  <div class="outer">
    <slot name="outer"></slot>
    <div class="inner">
      <div class="center-block">
        <div class="header">
          <i class="far fa-id-badge fa-2x"/>
          <div class="title">{{ this.$config.title }}</div>
          <div class="title">{{ title }}</div>
        </div>
        <div v-if="isSupportBrowser">
          <slot name="body"></slot>
        </div>
        <el-card v-else shadow="always">
          <p>お使いのブラウザでは本システムを利用いただけません。</p>
          <p>本システムでは以下のブラウザをお使いください。</p>
          <p>Google Chrome</p>
          <p>Mozilla Firefox</p>
          <p>Microsoft Edge</p>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
  computed: {
    isSupportBrowser: function() {
      let agent = window.navigator.userAgent.toLowerCase();
      if (agent.indexOf("edge") > -1) {
        return true;
      } else if (agent.indexOf("chrome") > -1) {
        return true;
      } else if (agent.indexOf("firefox") > -1) {
        return true;
      } else if (agent.indexOf("iphone") > -1) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.outer {
  height: 100%;
  background-color: #ccc;
  position: relative;
}
.inner {
  text-align: center;
  width: 80%;
  margin: 0 auto;
  max-width: 500px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}

.header {
  color: #666;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 0.5rem;
}

.center-block {
  background-color: #fff;
  border: 1px solid #eaeefb;
  border-radius: 6px;
  padding: 32px 16px 8px 16px;
}

.full-width-button {
  width: 100%;
}

.el-form-item {
  padding-bottom: 4px;
}

@media screen and (max-width: 600px) {
  .outer {
    margin: 0;
    background-color: #fff;
  }
  .inner {
    top: 0;
    width: 100%;
    transform: translateY(0%) translateX(-50%);
    -webkit-transform: translateY(0%) translateX(-50%);
  }
  .center-block {
    border: none;
  }

  .login-block {
    border: 0;
  }
}
</style>
